import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.dataPointsAlreadyAdded, action) => {
  switch (action.type) {
    case types.SET_DATAPOINTS_ALREADY_ADDED:
      return action.payload;
    default:
      return state;
  }
}
